import { useMediaQuery } from 'react-responsive';

import { getChatToken } from '~platform/auth';

import { config } from '~shared/config';
import { FEATURE_FLAGS } from '~shared/growthbook';
import { MEDIA_QUERY_MIN_WIDTH } from '~shared/lib/responsive';

import { ChatbotWidget } from '@breezeventures/web-ph-chatbot';
import { IfFeatureEnabled } from '@growthbook/growthbook-react';

import { useSyncChatSegment } from '../lib/use-sync-chat-segment';

const chatConfig = {
  tmsg: {
    url: config.chatUrl,
    wsUrl: config.chatWsUrl,
    product: config.chatProduct,
    integratorName: config.chatIntegratorName,
    location: config.chatLocation,
  },
};

export const AppChatWidget = () => {
  const isUpLd = useMediaQuery({ query: MEDIA_QUERY_MIN_WIDTH.lg });

  useSyncChatSegment();

  return (
    <IfFeatureEnabled feature={FEATURE_FLAGS.CHATBOT_ENABLED}>
      <ChatbotWidget
        config={chatConfig}
        getChatToken={getChatToken}
        isFullScreen={!isUpLd}
      />
    </IfFeatureEnabled>
  );
};
